import PlatformLayout from './PlatformLayout';

export default PlatformLayout;
